/**
 * Resolve a persisted preference value against its defaults. For object-shaped
 * prefs the persisted blob is shallow-merged OVER the defaults, so a partial /
 * older-schema row (missing top-level keys) can't surface `undefined` for a key
 * the consumer treats as always-present (e.g. grid prefs'
 * columnOrder/columnVisibility/density/pageSize). Scalar and array prefs keep
 * wholesale-replace semantics (the persisted value wins outright).
 *
 * Pure + dependency-free so it can be unit-tested without the React/Supabase
 * client surface of `useUserPreferences`.
 */
export function mergePersistedPreference<T>(base: T, loaded: T): T {
  const isPlainObject = (v: unknown): v is Record<string, unknown> =>
    typeof v === 'object' && v !== null && !Array.isArray(v);
  if (isPlainObject(loaded) && isPlainObject(base)) {
    return { ...base, ...loaded } as T;
  }
  return loaded;
}
